var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_9409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7251 8.75C15.7917 8.75 17.4684 7.07031 17.4684 5C17.4684 2.92969 15.7917 1.25 13.7251 1.25C11.6586 1.25 9.98192 2.92969 9.98192 5C9.98192 5.15625 9.98972 5.3125 10.0092 5.46484L6.34008 7.30078C5.66942 6.64844 4.75311 6.25 3.74322 6.25C1.67665 6.25 0 7.92969 0 10C0 12.0703 1.67665 13.75 3.74322 13.75C4.75311 13.75 5.66942 13.3516 6.34008 12.6992L10.0092 14.5352C9.98972 14.6875 9.98192 14.8398 9.98192 15C9.98192 17.0703 11.6586 18.75 13.7251 18.75C15.7917 18.75 17.4684 17.0703 17.4684 15C17.4684 12.9297 15.7917 11.25 13.7251 11.25C12.7152 11.25 11.7989 11.6484 11.1283 12.3008L7.45914 10.4648C7.47864 10.3125 7.48644 10.1602 7.48644 10C7.48644 9.83984 7.47864 9.6875 7.45914 9.53516L11.1283 7.69922C11.7989 8.35156 12.7152 8.75 13.7251 8.75Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_9409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4684,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d7cb58fe3fde3186e14be76f9640913f.svg";
export { ForwardRef as ReactComponent };